"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _zod = require("zod");

var _index = _interopRequireDefault(require("../cards/index"));

var _toKebabCase = require("@insided/shared/utils/toKebabCase");

var _widgetContainer = _interopRequireWildcard(require("../widget-container"));

var _utils = require("@insided/deprecated-preact-components/community-category/utils");

var _Metadata = _interopRequireDefault(require("@insided/deprecated-preact-components/community-category/Metadata"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var widgetName = 'community_category';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-community_category';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  selectedTemplate: _zod.z.number(),
  displayOnlyParent: _zod.z.boolean()
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;

var CommunityCategoryWrapper = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CommunityCategoryWrapper, _Component);

  var _super = _createSuper(CommunityCategoryWrapper);

  function CommunityCategoryWrapper() {
    var _this;

    (0, _classCallCheck2.default)(this, CommunityCategoryWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "templates", ['big-card', 'small-card']);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderCard", function (category, idx, isChild) {
      var _this$props = _this.props,
          config = _this$props.config,
          attachmentCdn = _this$props.attachmentCdn;
      var selectedTemplate = config.selectedTemplate;
      var id = category.id,
          title = category.title,
          children = category.children,
          thumbnailImage = category.thumbnailImage,
          visibleTopicsCount = category.visibleTopicsCount,
          url = category.url;
      var categoriesV2Data = isChild ? category : children;

      var _getMetadata = (0, _utils.getMetadata)(categoriesV2Data, visibleTopicsCount),
          totalTopicCount = _getMetadata.totalTopicCount,
          categoriesCount = _getMetadata.categoriesCount;

      var kebabCasedTitle = (0, _toKebabCase.textToKebab)(category.title);
      var imgSrc = thumbnailImage && "".concat(attachmentCdn).concat(thumbnailImage);
      var childClass = isChild ? "id-".concat(id, " title-").concat(kebabCasedTitle) : '';
      var hasWidgetTitle = Boolean(config.title);
      var hasWidgetSubtitle = Boolean(config.subtitle);
      var CardHeaderTag = (0, _widgetContainer.genericWidgetHeaderTagCalculator)(hasWidgetTitle, hasWidgetSubtitle);
      return (0, _preact.h)(_index.default, {
        key: id,
        customClass: "community-category__card community-category__card-".concat(_this.templates[selectedTemplate || 0], " ").concat(childClass),
        title: title,
        metadata: (0, _preact.h)(_Metadata.default, {
          totalTopicCount: totalTopicCount,
          categoriesCount: categoriesCount
        }),
        imageSrc: imgSrc,
        headerTag: CardHeaderTag,
        navigation: {
          url: url
        }
      });
    });
    return _this;
  }

  (0, _createClass2.default)(CommunityCategoryWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          config = _this$props2.config,
          categoriesV2 = _this$props2.categoriesV2;
      var title = config.title,
          displayOnlyParent = config.displayOnlyParent;

      if (!(categoriesV2 !== null && categoriesV2 !== void 0 && categoriesV2.length)) {
        return null;
      }

      return (0, _preact.h)(_widgetContainer.default, {
        config: config,
        widgetName: "community-category"
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('full-width Template-brand-featured community-category-container qa-community-category-container custom-community-category')
      }, (0, _preact.h)("div", {
        className: "community-category-list"
      }, displayOnlyParent ? categoriesV2.map(function (category, idx) {
        return _this2.renderCard(category, idx, false);
      }) : (0, _preact.h)("div", {
        className: "community-category-list_parent-child-component-wrapper"
      }, categoriesV2.map(function (category) {
        return (0, _preact.h)("section", {
          className: "community-category-list_parent-child-component",
          key: category.id
        }, title ? (0, _preact.h)("div", {
          className: "community-category-list_parent-title"
        }, category.title) : (0, _preact.h)("h3", {
          className: "widget__heading"
        }, category.title), (0, _preact.h)("div", {
          className: "community-category-list"
        }, category.children.map(function (subcategory, idx) {
          return _this2.renderCard(subcategory, idx, true);
        })));
      })))));
    }
  }]);
  return CommunityCategoryWrapper;
}(_preact.Component);

var _default = CommunityCategoryWrapper;
exports.default = _default;